import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { disable_pi_loading : true, disable_pi: '',disable_pi_error: false};

export function disablePi(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_DISABLE_PI:
        return {
            disable_pi_loading: true,
            disable_pi: '',
            disable_pi_error: false
        };
      case organisationConstants.RESPONSE_DISABLE_PI:
        return {
            disable_pi_loading: false,
            disable_pi: action.disable_pi,
            disable_pi_error: false
        };
      case organisationConstants.ERROR_DISABLE_PI:
        return { 
            disable_pi_loading: false,
            disable_pi: '',
            disable_pi_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/disablePi.reducer.js